import * as React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { RouteComponentProps } from 'react-router';
import { initializeIcons } from '@fluentui/react';
import {
    getMeetingData,
    getFilteredMetricsItemData,
    createOnlineMeetingAndUpdateStatus,
    endCall,
    cancelCall,
    getQueueById,
    getQueuesStatusCount,
    getStartedQueues,
    getEndedQueues,
    getExpiredQueues,
    getAttendancesReportData,
    getGeneralViewUnidadeData,
    getGeneralViewData,
    getMetricsData,
    getAllQueuesData,
    getAtendentesFilter,
    getUserPermissions,
    isAdmin,
} from '../../api/teamsapp-api';
import { getUserSettings, updateUserSettings } from '../../api/user-api';
import { getAppSettings } from '../../api/settings-api';
import { Dialog, Flex, FlexItem, Image, Segment, Text } from '@fluentui/react-northstar';
import { ExclamationTriangleIcon } from '@fluentui/react-icons-northstar';
import { debounce } from 'lodash';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { ITaskInfo } from '../../interfaces/taskInfo';
import { IPainelAtendimentoState } from "./interfaces/interfaces";
import VisaoGeralAtendimentosPorStatus from './visao-geral-atendimentos-status/visao-geral-atendimentos-status';
import VisaoGeralAtendimentos from '../shared/visao-geral-atendimentos/visao-geral-atendimentos';
import RelatorioAtendimentos from '../shared/relatorio-atendimentos/relatorio-atendimentos';
import LoaderList from "../loaders/loaderList";
import LoaderPainel from "../loaders/loaderPainel";
import ListagemFila from "./listagem-atendimentos/listagem-fila";
import ListagemIniciado from "./listagem-atendimentos/listagem-iniciado";
import ListagemEncerrado from "./listagem-atendimentos/listagem-encerrado";
import ListagemExpirado from "./listagem-atendimentos/listagem-expirado";
import ToolbarPainel from "./toolbar/toolbar";
import StatusQueueConstants from "../../constants/status-queue";
import Channels from '../../constants/channels';
import Errors from "../../constants/errors";
import Roles from "../../constants/roles";
import "./painel-atendimento.scss";
const moment = require('moment');

export type IPainelAtendimentoProps = {} & RouteComponentProps & WithTranslation;

enum EStatus {
    fila = 1,
    iniciados = 2,
    encerrados = 3,
    expirados = 4,
}

class PainelAtendimento extends React.Component<IPainelAtendimentoProps, IPainelAtendimentoState> {
    private localize: TFunction;
    private defaultPageSize: number = 15;
    
    ancora?: any = null;
    serventiaTitle?: any = null;
    serventiaMeetingUrl?: any = null;
    theme?: any = null;
    upn?: any = null;
    aadId?: any = null;
    user?: any = null;
    tid?: any = null;
    appId?: any = null;
    searchParam?: any = null;
    dateParam?: any = null;

    constructor(props: IPainelAtendimentoProps) {
        super(props);

        this.localize = this.props.t;
        initializeIcons();

        this.state = {
            totalItemsCount: [],
            fila: [],
            iniciados: [],
            encerrados: [],
            expirados: [],
            appConfigs: null,
            loading: true,
            pageSize: this.defaultPageSize,
            offset: 0,
            sortedColumn: "Name",
            sortDirection: "Down",
            totalFilterChecked: 0,
            itemsSecaoFilter: [],
            metricsFiltered: [],
            totalIndex: 0,
            totalMetricsFiltered: [],
            loadingTotalMetricsFiltered: false,
            loadingRows: false,
            loadingInfinite: true,
            isAdmin: false,
            serventia: [],
            loadingMetricsFiltered: false,
            relatorioAtendimentosFilteredMetrics: [],
            relatorioAtendimentosIndex: 0,
            loadingAtendimentosPorStatusMetricsFiltered: false,
            atendimentosPorStatusMetricsFiltered: [],
            atendimentosPorStatusIndex: 0,
            atendimentosMetricsFiltered: [],
            atendimentosTotalMetrics: [],
            loadingAtendimentosMetricsFiltered: false,
            loadingAtendimentosTotalMetrics: false,
            atendimentosIndex: 0,
            userSettings: [],
            status: EStatus.fila,
            statusLabel: this.localize("SolicitacoesAguardandoAtendimento"),
            queueCount1: [],
            queueCount2: [],
            queueCount3: [],
            queueCount4: [],
            interval: null,
            isDeleted: false,
            startedCall: false,
            startedCallAttendant: "",
            validateCreateQueue: true,
            validateQueueErrorText: "",
            isScheduledQueue: false,
            selectedDateFilter: new Date(),
            selectedDateLabel: this.localize("Hoje"),
            authEnabled: false,
            govBrEnabled: false,
            isFuture: false,
            isPast: false,
            collapsed: true,
            selectedFilter: "",
            atendentes: [],
            selectedAtendenteFilter: "",
            internalAccessEnabled: false,
            role: Roles.leitor,
            features: [],
        };

        this.searchParam = new URLSearchParams(window.location.search);
        this.onScrollDebounced = debounce(this.onScrollDebounced, 500);
    }

    public componentDidMount = async () => {
        microsoftTeams.initialize();

        microsoftTeams.getContext((context: any) => {
            this.ancora = context.subEntityId.split(", ")[0];
            this.serventiaTitle = context.subEntityId.split(", ")[1];
            this.appId = this.searchParam.get("appId");
            this.theme = context.theme;
            this.upn = context.userPrincipalName;
            this.aadId = context.userObjectId;
            this.user = context.loginHint;
            this.tid = context.tid;
            this.dateParam = context.subEntityId.split(", ")[2];

            this.isAdmin()
                .then(this.getUserSettings);
        });
    }

    // Init methods
    public init = async () => {
        if (this.ancora) {
            this.getMeeting();
            this.addLastViewUnidade();
        } else {
            this.ancora = this.state.userSettings.lastViewUnidadeAncora;
            this.serventiaTitle = this.state.userSettings.lastViewUnidadeTitle;

            if (this.ancora)
                this.getMeeting();
        }

        if (this.dateParam) {
            this.applyFilters(new Date(this.dateParam), null);
        }

        this.setState({
            interval: setInterval(() => this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
        });

        this.getAppSettings();
        this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true);
        this.getFilteredMetrics(1);
        this.getFilteredAllMetrics(7, 0);
        this.getAtendimentosPorStatusFilteredMetrics(0);
        this.getAtendimentosFilteredMetrics(0);
        this.getAtendimentosTotalMetrics();
        this.getRelatorioAtendimentosFilteredMetrics(7);
        this.getAtendentes(this.state.selectedDateFilter);
    }

    // Get App Audience
    public isAdmin = async () => {
        try {
            let response = await isAdmin();

            if (response.status === 200 && response.data) {
                this.setState({
                    isAdmin: response.data,
                    role: Roles.gestor,
                });
            } else {
                getUserPermissions().then((response: any) => {
                    this.setState({
                        role: response.data,
                        isAdmin: false,
                    })
                })
            }
        } catch (err) {
            getUserPermissions().then((response: any) => {
                this.setState({
                    role: response.data,
                    isAdmin: false,
                })
            })
        }
    };

    //Get user settings.
    public getUserSettings = async () => {
        let responseGet = await getUserSettings();

        if (responseGet.data) {
            this.setState({
                userSettings: responseGet.data
            })

            this.init();
        }
        else {
            window.location.href = `/errorpage/${Errors.invalidUserData}`;
        }
    }

    //Get app settings.
    public getAppSettings = async () => {
        let response = await getAppSettings();

        if (response.status === 200 && response.data) {
            this.setState({
                features: response.data.featuresList,
            })
        }
    }

    //Get serventia by id.
    public getMeeting = async () => {
        let response = await getMeetingData(this.ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                serventia: response.data,
                isDeleted: response.data.deleted,
                isScheduledQueue: response.data.scheduledQueue,
                authEnabled: response.data.authEnabled,
                govBrEnabled: response.data.govBrEnabled,
                internalAccessEnabled: response.data.supportedChannels?.includes(Channels.bot),
            })
        }
    }

    //Insert the last view unit
    public addLastViewUnidade = async () => {
        this.state.userSettings.lastViewUnidadeAncora = this.ancora;
        this.state.userSettings.lastViewUnidadeTitle = this.serventiaTitle;

        await updateUserSettings(this.state.userSettings);
    }

    // Get in queue data.
    public getInQueueData = async (offset: number, date?: Date | null, atendenteId?: string, filters?: string, alive?: boolean) => {
        if (date)
            date = moment(date).toISOString();

        let response = await getAllQueuesData(this.ancora, offset, this.defaultPageSize, date, atendenteId, filters);

        if (response.status === 200 && response.data) {
            this.setState({
                fila: alive ? response.data : [...this.state.fila, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            })
        }

        this.getQueuesStatusCount(date, atendenteId, filters)
    }

    // Get started queue data. 
    public getStartedQueueData = async (offset: number, date?: Date | null, atendenteId?: string, filters?: string, alive?: boolean) => {
        if (date)
            date = moment(date).toISOString();

        let response = await getStartedQueues(this.ancora, offset, this.defaultPageSize, date, atendenteId, filters);

        if (response.status === 200 && response.data) {
            this.setState({
                iniciados: alive ? response.data : [...this.state.iniciados, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            })
        }

        this.getQueuesStatusCount(date, atendenteId, filters)
    }

    // Get ended queue data. 
    public getEndedQueueData = async (offset: number, date?: Date | null, atendenteId?: string, filters?: string) => {
        if (date)
            date = moment(date).toISOString();

        let response = await getEndedQueues(this.ancora, offset, this.defaultPageSize, date, atendenteId, filters);

        if (response.status === 200 && response.data.length) {
            this.setState({
                encerrados: [...this.state.encerrados, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            })
        }

        this.getQueuesStatusCount(date, atendenteId)
    }

    // Get expired queue data. 
    public getExpiredQueueData = async (offset: number, date?: Date | null, filters?: string) => {
        if (date)
            date = moment(date).toISOString();

        let response = await getExpiredQueues(this.ancora, offset, this.defaultPageSize, date, filters);

        if (response.status === 200 && response.data) {
            this.setState({
                expirados: [...this.state.expirados, ...response.data],
                loadingRows: false,
            });
        } else {
            this.setState({
                loadingRows: false,
                loadingInfinite: false,
            })
        }

        this.getQueuesStatusCount(date, filters)
    }

    // Get queues status count.
    public getQueuesStatusCount = async (date?: Date | null, atendenteId?: string, filters?: string) => {
        if (date) {
            date = moment(date).toISOString();
        }

        let response = await getQueuesStatusCount(this.ancora, date, atendenteId, filters);

        if (response.status === 200 && response.data) {
            this.setState({
                queueCount1: response.data.filter((queue: any) => queue.status == StatusQueueConstants.naFila || queue.status == StatusQueueConstants.atendimentoAgendado),
                queueCount2: response.data.filter((queue: any) => queue.status == StatusQueueConstants.atendimentoIniciado || queue.status == StatusQueueConstants.emAtendimento),
                queueCount3: response.data.filter((queue: any) => (queue.status == StatusQueueConstants.atendimentoEncerrado || queue.status == StatusQueueConstants.atendimentoInativo || queue.status == StatusQueueConstants.atendimentoCancelado) && (!queue.expired || queue.status == StatusQueueConstants.atendimentoCancelado)),
                queueCount4: response.data.filter((queue: any) => queue.status == StatusQueueConstants.atendimentoInativo && queue.expired),
            })
        }
    }

    // Get Filtered Metrics Data
    public getFilteredMetrics = async (filter: any) => {
        let response = await getFilteredMetricsItemData(this.ancora, filter);
        if (response.status === 200 && response.data) {
            this.setState({
                metricsFiltered: response.data
            });
        }
    }

    // Get Filtered All Metrics
    public getFilteredAllMetrics = async (filter: any, index: number) => {
        this.setState({
            loadingTotalMetricsFiltered: true,
        })

        let response = await await getFilteredMetricsItemData(this.ancora, filter);
        if (response.status === 200 && response.data) {
            this.setState({
                totalMetricsFiltered: response.data,
                loadingTotalMetricsFiltered: false,
                totalIndex: index,
            });
        }
    }

    // Get visão geral atendimentos filter metrics
    public getAtendimentosPorStatusFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingAtendimentosPorStatusMetricsFiltered: true,
            });
        }

        let response = await getGeneralViewUnidadeData(this.ancora, daysCount);
        if (response.status === 200 && response.data) {
            this.setState({
                atendimentosPorStatusMetricsFiltered: response.data,
                loadingAtendimentosPorStatusMetricsFiltered: false,
                atendimentosPorStatusIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                atendimentosPorStatusMetricsFiltered: null,
                loadingAtendimentosPorStatusMetricsFiltered: false,
            });
        }
    }

    // Get visão geral filter metrics by ancora
    public getAtendimentosFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingAtendimentosMetricsFiltered: true,
            });
        }

        let response = await getGeneralViewData(daysCount, this.ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                atendimentosMetricsFiltered: response.data,
                loadingAtendimentosMetricsFiltered: false,
                atendimentosIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                atendimentosMetricsFiltered: null,
                loadingAtendimentosMetricsFiltered: false,
            });
        }
    }

    // Get visão geral total metrics by ancora
    public getAtendimentosTotalMetrics = async () => {
        this.setState({
            loadingAtendimentosTotalMetrics: true,
        });

        let response = await getMetricsData(this.ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                atendimentosTotalMetrics: response.data,
                loadingAtendimentosTotalMetrics: false,
            });
        } else {
            this.setState({
                atendimentosTotalMetrics: null,
                loadingAtendimentosTotalMetrics: false,
            });
        }
    }

    // Get relatório de atendimentos.
    public getRelatorioAtendimentosFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingMetricsFiltered: true,
            });
        }

        let response = await getAttendancesReportData(daysCount, this.ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                relatorioAtendimentosFilteredMetrics: response.data,
                loadingMetricsFiltered: false,
                relatorioAtendimentosIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                relatorioAtendimentosFilteredMetrics: null,
                loadingMetricsFiltered: false,
            });
        }
    }

    // Filter assunto or protocol.
    public filterAssuntoOrProtocol = async (filter: string) => {
        clearInterval(this.state.interval);

        this.setState({
            selectedFilter: filter,
            status: EStatus.fila,
            interval: null,
        }, () => {
            this.setActiveTabId(EStatus.fila);
        })
    }

    // Get unit atendentes
    public getAtendentes = async (date: Date) => {
        let response = await getAtendentesFilter(this.ancora, date);

        if (response.status === 200 && response.data) {
            this.setState({
                atendentes: response.data,
            })
        }
    }

    // Search
    public searchFilters = (e: React.SyntheticEvent<HTMLElement, Event>) => {
        let searchQuery = (e.target as HTMLInputElement).value;

        this.setState({
            selectedFilter: searchQuery,
        })
    }

    // Apply custom filters
    public applyFilters = (dateFilter: any, atendenteFilter: string | null) => {
        clearInterval(this.state.interval);

        if (atendenteFilter) {
            this.setState({
                selectedDateFilter: dateFilter,
                selectedAtendenteFilter: atendenteFilter,
                selectedFilter: "",
            }, () => {
                if (moment(dateFilter).isSame(moment(), "day")) {
                    this.setActiveTabId(EStatus.iniciados);
                } else {
                    if (moment(dateFilter).isBefore(moment(), "day"))
                        this.setActiveTabId(EStatus.encerrados);

                    if (moment(dateFilter).isAfter(moment(), "day"))
                        this.setActiveTabId(EStatus.fila);
                }
            })
        } else {
            this.dateChange(dateFilter);
        }
    }

    // Apply protocol or subject filter
    public applyProtocolFilter = () => {
        this.setState({
            status: 0,
            loadingRows: true,
            selectedAtendenteFilter: "",
        }, () => {
            clearInterval(this.state.interval);
            this.filterAssuntoOrProtocol(this.state.selectedFilter.replace(/#/g, ""));
        });
    }

    // Clear all filters
    public clearFilters = () => {
        this.setState({
            selectedFilter: "",
            loadingRows: true,
            status: EStatus.fila,
            statusLabel: this.localize("SolicitacoesAguardandoAtendimento"),
            selectedAtendenteFilter: "",
            selectedDateFilter: new Date(),
            isPast: false,
            isFuture: false,
        }, () => {
            clearInterval(this.state.interval);
            this.getInQueueData(this.state.offset, new Date());
            let keepAlive = setInterval(() => this.getInQueueData(this.state.offset, new Date(), "", "", true), 20000);
            this.setState({ interval: keepAlive });
        })
    }

    // Date filter change
    public dateChange = (date: any) => {
        this.setState({
            status: 0,
            selectedDateFilter: date,
            loadingRows: true,
        }, () => {
            if (moment(date).isSame(moment(), "day")) {
                this.setState({
                    isFuture: false,
                    isPast: false,
                });

                this.setActiveTabId(EStatus.fila);
            } else {
                if (moment(date).isBefore(moment(), "day")) {
                    this.setState({
                        isFuture: false,
                        isPast: true,
                        selectedDateLabel: moment(date).format("DD/MM/YY"),
                    });

                    this.setActiveTabId(EStatus.encerrados);
                }

                if (moment(date).isAfter(moment(), "day")) {
                    this.setState({
                        isFuture: true,
                        isPast: false,
                        selectedDateLabel: moment(date).format("DD/MM/YY"),
                    });

                    this.setActiveTabId(EStatus.fila);
                }
            }
        })
    }

    // Parse status labels
    public getLabelStatusLocale = (status?: string) => {
        if (status) {
            if (status == StatusQueueConstants.naFila)
                return this.localize("NaFila")
            else if (status == StatusQueueConstants.atendimentoIniciado)
                return this.localize("AtendimentoIniciado")
            else if (status == StatusQueueConstants.emAtendimento)
                return this.localize("EmAtendimento")
            else if (status == StatusQueueConstants.atendimentoEncerrado)
                return this.localize("AtendimentoEncerrado")
            else if (status == StatusQueueConstants.atendimentoInativo)
                return this.localize("AtendimentoInativo")
            else if (status == StatusQueueConstants.atendimentoCancelado)
                return this.localize("AtendimentoCancelado")
            else if (status == StatusQueueConstants.atendimentoAgendado)
                return this.localize("Agendado")
        }
    }

    // Get tab status locale
    public getTabStatusLocale() {
        return [
            { title: this.localize("SolicitacoesAguardandoAtendimento") },
            { title: this.localize("AtendimentosIniciados") },
            { title: this.localize("EmAtendimento") },
            { title: this.localize("SolicitacoesExpiradas") },
        ]
    }

    //"Search function"
    public onScroll = (e: any) => {
        if (e.target.className == "main-component-painel")
            this.onScrollDebounced(e.target)
    }

    // Scroll infinite pagination
    public onScrollDebounced = (e: any) => {
        const bottom = Math.floor(e.scrollHeight - e.scrollTop) <= Math.floor(e.clientHeight);

        if (!this.state.loadingInfinite)
            return;

        if (bottom && !this.state.loadingRows) {
            clearInterval(this.state.interval);

            this.setState({
                offset: this.state.offset + this.defaultPageSize,
                interval: null,
            }, () => {
                { this.state.status == EStatus.fila && this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedFilter) }
                { this.state.status == EStatus.iniciados && this.getStartedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter) }
                { this.state.status == EStatus.encerrados && this.getEndedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter) }
                { this.state.status == EStatus.expirados && this.getExpiredQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedFilter) }
            })
        }
    }

    // Set active tab
    public setActiveTabId = (index: number) => {
        clearInterval(this.state.interval);

        this.setState({
            status: index,
            statusLabel: this.getTabStatusLocale()[index - 1].title,
            loadingRows: true,
            loadingInfinite: true,
            offset: 0,
            pageSize: this.defaultPageSize,
            fila: [],
            iniciados: [],
            encerrados: [],
            expirados: [],
            interval: null,
        }, () => {
            if (index == EStatus.fila) {
                this.setState({
                    interval: setInterval(() => this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
                });

                this.getInQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true)
            }

            if (index == EStatus.iniciados) {
                this.setState({
                    interval: setInterval(() => this.getStartedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true), 20000)
                });

                this.getStartedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter, true)
            }

            if (index == EStatus.encerrados) {
                this.getEndedQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedAtendenteFilter, this.state.selectedFilter)
            }

            if (index == EStatus.expirados) {
                this.getExpiredQueueData(this.state.offset, this.state.selectedDateFilter, this.state.selectedFilter)
            }

        })
    }

    // Atender atendimento
    public atender = (item: any) => {
        item.loadingMeeting = true;

        this.setState({
            fila: this.state.fila
        })

        getQueueById(item.id).then((queue: any) => {
            if (queue.data.status == StatusQueueConstants.atendimentoIniciado ||
                queue.data.status == StatusQueueConstants.emAtendimento) {

                this.setState({
                    startedCall: true,
                    startedCallAttendant: queue.data.atendenteName,
                })
            } else if (queue.data.status == StatusQueueConstants.naFila || queue.data.status == StatusQueueConstants.atendimentoAgendado) {
                createOnlineMeetingAndUpdateStatus(item.id, item.Ancora, this.appId).then((response: any) => {
                    this.setState({
                        fila: this.state.fila,
                    })

                    if (response.data.id) {
                        microsoftTeams.executeDeepLink(response.data.meetingUrl)
                        this.getInQueueData(this.state.offset, this.state.selectedDateFilter)
                            .then(() => this.setActiveTabId(EStatus.iniciados));
                    } else {
                        this.setState({
                            validateCreateQueue: false,
                            validateQueueErrorText: response.data,
                        })
                    }

                })
            }
        })
    }

    // Finalizar atendimento
    public finalizar = (item: any) => {
        endCall(item.id).then(() => {
            item.loadingEndMeeting = false;
            this.getInQueueData(this.state.offset, this.state.selectedDateFilter).then(() => this.setActiveTabId(EStatus.encerrados));
        })
    }

    // Task module details
    public onViewHistory = (queueId: any) => {
        let taskInfo: ITaskInfo = {
            url: window.location.origin + `/post-meeting-panel/${queueId}/${this.ancora}`,
            title: this.localize("Detalhes"),
            height: 650,
            width: 930,
        }

        microsoftTeams.tasks.startTask(taskInfo);
    }

    // Schedule queue
    public agendar = (queueId?: string | null) => {
        let taskInfo: ITaskInfo = {
            url: window.location.origin + `/agendamento?ancora=${this.ancora}&appId=${this.appId}${queueId ? `&queueId=${queueId}` : ''}`,
            title: this.localize("Agendamento"),
            height: 490,
            width: 750,
        }

        let submitHandler = (err: string, result: any): void => {
            if (result) {
                this.setActiveTabId(EStatus.fila)
            }
        };

        microsoftTeams.tasks.startTask(taskInfo, submitHandler);
    }

    // Cancel meeting
    public onCancelCall = (queueId: any) => {
        cancelCall(queueId).then(() => {
            this.getInQueueData(this.state.offset, this.state.selectedDateFilter).then(() => this.setActiveTabId(EStatus.encerrados));
        })
    }

    // Collapse charts area
    public collapseCharts = (collapsed: boolean) => {
        this.setState({
            collapsed: collapsed
        })
    }

    // Validate create queue
    public onValidateCreateQueue = () => {
        this.setState({ validateCreateQueue: true })
    }

    public render = () => {
        return (
            this.state.metricsFiltered.length == 0 ||
                this.state.loadingAtendimentosTotalMetrics ||
                this.state.loadingAtendimentosMetricsFiltered ||
                this.state.loadingAtendimentosPorStatusMetricsFiltered ||
                this.state.loadingMetricsFiltered ?
                <LoaderPainel />
                :
                !this.ancora ?
                    <div className="main-component-painel">
                        <Flex className="form-container" column>
                            <Flex>
                                <Flex vAlign="center" hAlign="center" styles={{ width: "100%", height: "100vh" }}>
                                    <Flex hAlign="center" gap="gap.large" column style={{ width: "100%", maxWidth: "43.5rem", margin: "0rem 1.25rem", height: "90rem" }}>
                                        <Image src="/images/empty-unit.svg" />
                                        <Text size="larger" content="Você ainda não acessou uma unidade." />
                                        <Text content={this.localize("SelecioneServentia")} />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>
                    </div>
                    :
                    <div className="main-component-painel" onScroll={this.onScroll}>
                        <div className="form-container">
                            <Flex gap="gap.large" space="between">
                                <FlexItem size="size.quarter">
                                    <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                        {<VisaoGeralAtendimentos
                                            metrics={this.state.atendimentosMetricsFiltered}
                                            totalMetrics={this.state.atendimentosTotalMetrics}
                                            filter={this.getAtendimentosFilteredMetrics}
                                            index={this.state.atendimentosIndex}
                                            customTitle={this.serventiaTitle}
                                            collapseCharts={this.collapseCharts}
                                            collapsed={this.state.collapsed}
                                        />}
                                    </Segment>
                                </FlexItem>

                                <FlexItem size="size.quarter">
                                    <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                        <VisaoGeralAtendimentosPorStatus
                                            metrics={this.state.atendimentosPorStatusMetricsFiltered}
                                            filter={this.getAtendimentosPorStatusFilteredMetrics}
                                            index={this.state.atendimentosPorStatusIndex}
                                            collapseCharts={this.collapseCharts}
                                            collapsed={this.state.collapsed}
                                        />
                                    </Segment>
                                </FlexItem>

                                <FlexItem size="size.half">
                                    <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                        {<RelatorioAtendimentos
                                            metrics={this.state.relatorioAtendimentosFilteredMetrics}
                                            filter={this.getRelatorioAtendimentosFilteredMetrics}
                                            index={this.state.relatorioAtendimentosIndex}
                                            collapseCharts={this.collapseCharts}
                                            collapsed={this.state.collapsed}
                                        />}
                                    </Segment>
                                </FlexItem>
                            </Flex>

                            <Flex hidden={this.state.isDeleted} space="between" className="toolbar-painel">
                                <ToolbarPainel
                                    ancora={this.ancora}
                                    status={this.state.status}
                                    setActiveTabId={this.setActiveTabId}
                                    queueCount1={this.state.queueCount1}
                                    queueCount2={this.state.queueCount2}
                                    queueCount3={this.state.queueCount3}
                                    queueCount4={this.state.queueCount4}
                                    agendar={this.agendar}
                                    isScheduledQueue={this.state.isScheduledQueue}
                                    dataChange={this.dateChange}
                                    selectedDateFilter={this.state.selectedDateFilter}
                                    selectedDateLabel={this.state.selectedDateLabel}
                                    isFuture={this.state.isFuture}
                                    isPast={this.state.isPast}
                                    searchFilters={this.searchFilters}
                                    selectedFilter={this.state.selectedFilter}
                                    clearFilters={this.clearFilters}
                                    applyFilters={this.applyFilters}
                                    applyProtocolFilter={this.applyProtocolFilter}
                                    atendentes={this.state.atendentes}
                                    getAtendentesByDate={this.getAtendentes}
                                    selectedAtendenteFilter={this.state.selectedAtendenteFilter}
                                    role={this.state.role}
                                    isAdmin={this.state.isAdmin}
                                    collapseCharts={this.collapseCharts}
                                    collapsed={this.state.collapsed}
                                    features={this.state.features}
                                />
                            </Flex>

                            <div style={{ position: "relative", zIndex: 999, boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Flex className="form-content-container" column>
                                    {(!this.state.loadingRows && !this.state.isDeleted && this.state.status == 0) &&
                                        <Flex hAlign="center" gap="gap.medium" styles={{ marginTop: '60px' }}>
                                            <ExclamationTriangleIcon outline />
                                            <Text size="small" weight="light" content={`Não existem atendimentos com o filtro selecionado.`} />
                                        </Flex>
                                    }

                                    {this.state.loadingRows && <LoaderList />}

                                    <Dialog
                                        open={this.state.startedCall}
                                        onConfirm={() => this.setState({ startedCall: false })}
                                        confirmButton="Ok"
                                        content={`${this.localize("SolicitacaoJaAtendida")} ${this.state.startedCallAttendant}.`}
                                        header={this.localize("AtenderEstaSolicitacao")}
                                    />

                                    {(!this.state.loadingRows && this.state.status == EStatus.fila) &&
                                        <ListagemFila
                                            item={this.state.fila}
                                            status={this.state.statusLabel}
                                            isScheduledQueue={this.state.isScheduledQueue}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            onCancelCall={this.onCancelCall}
                                            validateCreateQueue={this.state.validateCreateQueue}
                                            validateQueueErrorText={this.state.validateQueueErrorText}
                                            onValidateCreateQueue={this.onValidateCreateQueue}
                                            startCall={this.atender}
                                            agendar={this.agendar}
                                            authEnabled={this.state.authEnabled}
                                            govBrEnabled={this.state.govBrEnabled}
                                            filtered={
                                                this.state.isPast ||
                                                this.state.isFuture ||
                                                (this.state.selectedFilter != "") ||
                                                (this.state.selectedAtendenteFilter != "")}
                                            internalAccessEnabled={this.state.internalAccessEnabled}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                        />
                                    }

                                    {(!this.state.loadingRows && this.state.status == EStatus.iniciados) &&
                                        <ListagemIniciado
                                            item={this.state.iniciados}
                                            status={this.state.statusLabel}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            authEnabled={this.state.authEnabled}
                                            govBrEnabled={this.state.govBrEnabled}
                                            aadId={this.aadId}
                                            finalizar={this.finalizar}
                                            internalAccessEnabled={this.state.internalAccessEnabled}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                        />
                                    }

                                    {(!this.state.loadingRows && this.state.status == EStatus.encerrados) &&
                                        <ListagemEncerrado
                                            item={this.state.encerrados}
                                            status={this.state.statusLabel}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            onViewHistory={this.onViewHistory}
                                            authEnabled={this.state.authEnabled}
                                            govBrEnabled={this.state.govBrEnabled}
                                            filtered={(this.state.selectedFilter != "") || (this.state.selectedAtendenteFilter != "")}
                                            internalAccessEnabled={this.state.internalAccessEnabled}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                        />
                                    }

                                    {(!this.state.loadingRows && this.state.status == EStatus.expirados) &&
                                        <ListagemExpirado
                                            item={this.state.expirados}
                                            status={this.state.statusLabel}
                                            getLabelStatusLocale={this.getLabelStatusLocale}
                                            onViewHistory={this.onViewHistory}
                                            role={this.state.role}
                                            isAdmin={this.state.isAdmin}
                                            pageSize={this.defaultPageSize}
                                            loadingInfinite={this.state.loadingInfinite}
                                        />
                                    }
                                </Flex>
                            </div>
                        </div>
                    </div>
        );
    }
}

const painelAtendimentoWithTranslation = withTranslation()(PainelAtendimento);
export default painelAtendimentoWithTranslation;
